/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {TableTanggal} from './TableTanggal'
import {useNavigate} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import swal from 'sweetalert'
import {withProtectedRoute} from '../../../utils/withProtectedRoute'

export const TanggalWrapper: FC = withProtectedRoute(() => {
  const {t} = useTranslation()

  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('CONFIG.DATE.TITLE')}</PageTitle>
      <TableTanggal className='card-xxl-stretch mb-5 mb-xl-8' />
    </>
  )
})
